import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_WAREHOUSES = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: WarehousePageFilter
	) {
		getWarehouses(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
				location {
					id
					name
				}
			}
			count
		}
	}
`;

const WarehouseSelector = (props) => {

	const { query, initialValue, value } = props;

	const resolvedInitialValue = initialValue || value;

	return (
		<SearchDropdownSelector
			query={query || GET_WAREHOUSES}
			initialValue={resolvedInitialValue}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select warehouse"
			{...props}
		/>
	);
};

export default WarehouseSelector;
